import { FC, Ref } from 'react';
import { Select, SelectProps } from '@chakra-ui/react';

export interface SelectFieldProps extends SelectProps {
  inputRef: Ref<HTMLSelectElement>;
  options: any[];
}

export const SelectField: FC<SelectFieldProps> = ({
  options,
  inputRef,
  ...rest
}) => (
  <Select borderRadius="4px" placeholder="Select" ref={inputRef} {...rest}>
    {options.map((option, i) => {
      const label = option.label ?? option.description ?? option;
      const value = option.value ?? option.code ?? option;
      return (
        <option key={`${i}-${label}`} value={value}>
          {label}
        </option>
      );
    })}
  </Select>
);

// export const SelectField: FC<SelectFieldProps> = forwardRef<
//   SelectFieldProps,
//   'select'
// >(({ defaultValue, options, ...rest }, ref) => (
//   <Select
//     {...rest}
//     ref={ref}
//     placeholder="Select"
//     defaultValue={defaultValue}
//     borderRadius="4px"
//   >
//     {options.map((option, i) => {
//       const label = option.label ?? option;
//       const value = option.value ?? option;
//       return (
//         <option key={`${i}-${label}`} value={value}>
//           {label}
//         </option>
//       );
//     })}
//   </Select>
// ));
